/** Wind blade (fx 'wind'): a crescent of wind leaves the blade and flies to the target, shedding leaves. */
import { registerFx } from './registry';

const R = Math.random;

registerFx('wind', (host) => ({
  skill: ({ src, tgt, style, sx, sy, tx, ty }) => {
    host.swingArc(src, style, '140,230,170');
    host.fx.push({
      type: 'wave',
      x: sx + host.iso.facing(src) * 10,
      y: sy - 18 * host.tall(src),
      t: 0,
      life: 0.22,
      x1: tx,
      y1: ty - 14 * host.tall(tgt),
      col: '150,240,180',
    });
    for (let k = 0; k < 12; k++)
      host.parts.push({
        x: sx + host.iso.facing(src) * 8,
        y: sy - 16 * host.tall(src),
        vx: (tx - sx) * 2.5 + (R() - 0.5) * 50,
        vy: (ty - sy) * 2.5 - 10 + (R() - 0.5) * 40,
        g: 20,
        t: 0,
        life: 0.5,
        c: R() < 0.5 ? '#8fe6a8' : '#d8ffd8',
        s: R() < 0.3 ? 2 : 1,
        drag: 1.5,
      });
    host.sfx.swing();
  },
}));
